export const USING_TYPE_WORK_HOLIDAY_APPLICATION = {
  CAN_BE: 0,
  NONE: 1,
};
